// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBQmKkHWnzfX4rNAoDjmMIRYHIGjMRbN3k',
    authDomain: 'idelivery-e9d29.firebaseapp.com',
    databaseURL: 'https://idelivery-e9d29.firebaseio.com',
    projectId: 'idelivery-e9d29',
    storageBucket: 'idelivery-e9d29.appspot.com',
    messagingSenderId: '935480234071',
    appId: '1:935480234071:web:dc4876d2dd4c7365ac5312',
    measurementId: 'G-WP3EYC5ZRW'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
